import { Component } from 'preact';

export default class BaseComponent extends Component {
  constructor(state) {
    super();
  }
}


// WEBPACK FOOTER //
// ./src/Display/Components/BaseComponent.js